import React from 'react';
import MonacoEditorWidget from './editor/MonacoEditorWidget';
import { editorFileNameForLanguage } from './editor/EditorBreadcrumb';

export default function CodeEditor({
  value,
  onChange,
  language = 'python',
  minRows = 16,
  readOnly = false,
  placeholder = 'Write your code here...',
  contentId,
  showToolbar = true,
  showStatusBar = true,
  onEditorMount,
  followAppTheme = false,
  fileName,
  showBreadcrumb = true,
  height: heightProp,
  themeId,
  fillHeight = false,
  onSave,
  onSaveAs,
}) {
  const height = heightProp ?? Math.max(minRows * 22, 400);

  return (
    <MonacoEditorWidget
      value={value || ''}
      onChange={onChange}
      language={language}
      readOnly={readOnly}
      height={height}
      contentId={contentId}
      showToolbar={showToolbar}
      showStatusBar={showStatusBar}
      onEditorMount={onEditorMount}
      followAppTheme={followAppTheme}
      fileName={fileName || editorFileNameForLanguage(language)}
      showBreadcrumb={showBreadcrumb}
      themeId={themeId}
      fillHeight={fillHeight}
      onSave={onSave}
      onSaveAs={onSaveAs}
    />
  );
}
